module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form__input-container"
  }, [_c('fieldset', {
    staticClass: "form__field"
  }, [(_vm.label) ? _c('label', {
    staticClass: "form__label tooltip",
    attrs: {
      "for": _vm.modelPath
    }
  }, [_vm._v("\n      " + _vm._s(_vm.L.localize(_vm.label))), (_vm.hasTooltip) ? _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.L.localize(_vm.tooltip)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'date' || _vm.type == 'datetime') ? _c('DatePicker', {
    attrs: {
      "value": _vm.value,
      "type": _vm.type,
      "data-acc": _vm.acc.toLowerCase()
    },
    on: {
      "input": _vm.updateValue
    }
  }) : (!_vm.multiLine) ? _c('input', {
    ref: "input",
    staticClass: "form__input",
    class: _vm.classes,
    attrs: {
      "autocomplete": _vm.autocomplete ? _vm.autocomplete : null,
      "disabled": _vm.disabled,
      "max": _vm.maxValue,
      "maxlength": _vm.enforceMaxlength ? _vm.maxlength : null,
      "min": _vm.minValue,
      "name": _vm.name,
      "data-acc": _vm.acc.toLowerCase(),
      "number": _vm.type === 'number' ? true : null,
      "placeholder": _vm.hasFloatingLabel ? null : _vm.L.localize(_vm.placeholder),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "step": _vm.stepValue,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": _vm.onBlur,
      "change": _vm.onChange,
      "focus": _vm.onFocus,
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeydownEnter.apply(null, arguments)
      }, _vm.onKeydown]
    }
  }) : _c('textarea', {
    ref: "textarea",
    staticClass: "form__input",
    attrs: {
      "autocomplete": _vm.autocomplete ? _vm.autocomplete : null,
      "disabled": _vm.disabled,
      "maxlength": _vm.enforceMaxlength ? _vm.maxlength : null,
      "name": _vm.name,
      "placeholder": _vm.hasFloatingLabel ? null : _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "data-acc": _vm.acc.toLowerCase()
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": _vm.onBlur,
      "change": _vm.onChange,
      "focus": _vm.onFocus,
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onKeydownEnter.apply(null, arguments)
      }, _vm.onKeydown]
    }
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.validate) ? _c('validation', {
    attrs: {
      "validate": _vm.validate[_vm.modelPath],
      "model": _vm.modelPath
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ui-textbox__content"
  }, [(_vm.hasFeedback || _vm.maxlength) ? _c('div', {
    staticClass: "ui-textbox__feedback"
  }, [(_vm.showError) ? _c('div', {
    staticClass: "ui-textbox__feedback-text"
  }, [_vm._t("error", function() {
    return [_vm._v(_vm._s(_vm.error))]
  })], 2) : (_vm.showHelp) ? _c('div', {
    staticClass: "ui-textbox__feedback-text"
  }, [_vm._t("help", function() {
    return [_vm._v(_vm._s(_vm.help))]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.maxlength) ? _c('div', {
    staticClass: "ui-textbox__counter"
  }, [_vm._v("\n                " + _vm._s(_vm.value.length + '/' + _vm.maxlength) + "\n            ")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fe8d5fb!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/forms/TextBox.vue
// module id = 744
// module chunks = 1